export default __webpack_public_path__ + "static/media/Discover.051cbac4.svg";